<template>
    <!-- <div> -->
    <!-- STEP 1 -->
    <div
        v-if="product"
        v-show="errorCode === 'already-purchased'"
        class="checkout__error checkout__error--step-2 error-new"
        :class="{ 'direction-rtl': isRTL }"
        id="checkout__error--credit-card-error"
        data-test="credit-card-error-modal">
        <div class="checkout__error-content">
            <span @click="close" class="checkout__error-close close-error-message" :style="isRTL ? { left: '15px', right: 'auto' } : {}">
                &times;
            </span>
            <div class="error-new__header">
                <img src="https://images.iphonephotographyschool.com/37648/already-own.svg" alt="" />
                <p :class="isRTL ? 'direction-rtl--align' : ''">{{ $t('errors_new.alreadyOwn') }} {{ product.title }}</p>
            </div>
            <div class="error-new__body" :class="isRTL ? 'direction-rtl--align' : ''">
                <p>{{ $t('errors_new.anotherCopy') }}</p>
                <p>{{ $t('errors_new.openPortal') }}</p>
                <button @click="close" class="checkout__button checkout__button--error close-error-message">
                    {{ $t('errors_new.enterAnotherEmail') }}
                </button>
                <a
                    href="https://courses.iphonephotographyschool.com/"
                    target="_blank"
                    class="error-new__secondary-button">
                    {{ $t('errors_new.goToPortal') }}
                </a>
            </div>
        </div>
    </div>
    <!-- END STEP 1 -->

    <!-- STEP 2 -->
    <div
        v-show="errorCode === 'checkout-credit-card-error'"
        class="checkout__error checkout__error--step-2 error-new"
        :class="{ 'direction-rtl': isRTL }"
        id="checkout__error--credit-card-error"
        data-test="credit-card-error-modal">
        <div class="checkout__error-content">
            <span @click="close" class="checkout__error-close close-error-message" :style="isRTL ? { left: '15px', right: 'auto' } : {}">
                &times;
            </span>
            <div class="error-new__header">
                <img src="https://images.iphonephotographyschool.com/37647/card-error-icon.svg" alt="" />
                <p v-html="$t('errors_new.errorTitle')" :class="isRTL ? 'direction-rtl--align' : ''"></p>
            </div>
            <div class="error-new__body" :class="isRTL ? 'direction-rtl--align' : ''">
                <p>
                    <b>{{ $t('errors_new.checkDetails') }}</b>
                </p>
                <p>{{ $t('errors_new.anotherPayment') }}</p>
                <button @click="close" class="checkout__button checkout__button--error close-error-message">
                    {{ $t('errors_new.tryAgain') }}
                </button>
            </div>
        </div>
    </div>

    <div
        v-show="errorCode === 'checkout-paypal-error' || errorCode === 'checkout-apple-pay-error'"
        class="checkout__error checkout__error--step-2 error-new"
        :class="{ 'direction-rtl': isRTL }"
        id="checkout__error--credit-card-error"
        data-test="credit-card-error-modal">
        <div class="checkout__error-content">
            <span @click="close" class="checkout__error-close close-error-message" :style="isRTL ? { left: '15px', right: 'auto' } : {}">
                &times;
            </span>
            <div class="error-new__header">
                <img src="https://images.iphonephotographyschool.com/37647/card-error-icon.svg" alt="" />
                <p v-html="$t('errors_new.errorTitle')" :class="isRTL ? 'direction-rtl--align' : ''"></p>
            </div>
            <div class="error-new__body" :class="isRTL ? 'direction-rtl--align' : ''">
                <p>
                    <b>{{ $t('errors_new.checkPaymentDetails') }}</b>
                </p>
                <p>{{ $t('errors_new.anotherPayment') }}</p>
                <button @click="close" class="checkout__button checkout__button--error close-error-message">
                    {{ $t('errors_new.tryAgain') }}
                </button>
            </div>
        </div>
    </div>

    <div
        v-show="errorCode === 'immediate-paypal-error' || errorCode === 'immediate-credit-card-error'"
        class="checkout__error checkout__error--step-2 error-new"
        :class="{ 'direction-rtl': isRTL }"
        id="checkout__error--credit-card-error"
        data-test="credit-card-error-modal">
        <div class="checkout__error-content">
            <span @click="close" class="checkout__error-close close-error-message" :style="isRTL ? { left: '15px', right: 'auto' } : {}">
                &times;
            </span>
            <div class="error-new__header">
                <img src="https://images.iphonephotographyschool.com/37647/card-error-icon.svg" alt="" />
                <p v-html="$t('errors_new.errorTitle')" :class="isRTL ? 'direction-rtl--align' : ''"></p>
            </div>
            <div class="error-new__body" :class="isRTL ? 'direction-rtl--align' : ''">
                <p>{{ $t('errors_new.differentPayment') }}</p>
                <button @click="close" class="checkout__button checkout__button--error close-error-message">
                    {{ $t('errors_new.buttonAnotherPayment') }}
                </button>
            </div>
        </div>
    </div>

    <div
        v-show="errorCode === 'credit-card-3-d-secure-error'"
        class="checkout__error checkout__error--step-2 error-new"
        :class="{ 'direction-rtl': isRTL }"
        id="checkout__error--credit-card-error"
        data-test="credit-card-error-modal">
        <div class="checkout__error-content">
            <span @click="close" class="checkout__error-close close-error-message" :style="isRTL ? { left: '15px', right: 'auto' } : {}">
                &times;
            </span>
            <div class="error-new__header">
                <img src="https://images.iphonephotographyschool.com/37647/card-error-icon.svg" alt="" />
                <p v-html="$t('errors_new.errorTitle')" :class="isRTL ? 'direction-rtl--align' : ''"></p>
            </div>
            <div class="error-new__body" :class="isRTL ? 'direction-rtl--align' : ''">
                <p>{{ $t('errors_new.3DS') }}</p>
                <p>{{ $t('errors_new.tryAgain3ds') }}</p>
                <button @click="close" class="checkout__button checkout__button--error close-error-message">
                    {{ $t('errors_new.tryAgain') }}
                </button>
            </div>
        </div>
    </div>

    <div
        v-show="errorCode === 'insufficient-funds'"
        class="checkout__error checkout__error--step-2 error-new"
        :class="{ 'direction-rtl': isRTL }"
        id="checkout__error--credit-card-error"
        data-test="credit-card-error-modal">
        <div class="checkout__error-content">
            <span @click="close" class="checkout__error-close close-error-message" :style="isRTL ? { left: '15px', right: 'auto' } : {}">
                &times;
            </span>
            <div class="error-new__header">
                <img src="https://images.iphonephotographyschool.com/37647/card-error-icon.svg" alt="" />
                <p v-html="$t('errors_new.errorTitle')" :class="isRTL ? 'direction-rtl--align' : ''"></p>
            </div>
            <div class="error-new__body" :class="isRTL ? 'direction-rtl--align' : ''">
                <p>
                    <b>{{ $t('errors_new.insufficientFunds') }}</b>
                </p>
                <p>{{ $t('errors_new.addFunds') }}</p>
                <button @click="close" class="checkout__button checkout__button--error close-error-message">
                    {{ $t('errors_new.tryAgain') }}
                </button>
            </div>
        </div>
    </div>

    <div
        v-show="errorCode === 'system-error'"
        class="checkout__error checkout__error--step-2 error-new"
        :class="{ 'direction-rtl': isRTL }"
        id="checkout__error--credit-card-error"
        data-test="credit-card-error-modal">
        <div class="checkout__error-content">
            <span @click="close" class="checkout__error-close close-error-message" :style="isRTL ? { left: '15px', right: 'auto' } : {}">
                &times;
            </span>
            <div class="error-new__header">
                <img src="https://images.iphonephotographyschool.com/37647/card-error-icon.svg" alt="" />
                <p v-html="$t('errors_new.errorTitle')" :class="isRTL ? 'direction-rtl--align' : ''"></p>
            </div>
            <div class="error-new__body" :class="isRTL ? 'direction-rtl--align' : ''">
                <p>
                    <b>{{ $t('errors_new.technicalIssue') }}</b>
                </p>
                <p>
                    {{ $t('errors_new.messageAgain') }} <a v-bind:href="'mailto:' + supportEmail">{{ supportEmail }}</a
                    >{{ $t('errors_new.oneBusinessDay') }}
                </p>
                <button @click="close" class="checkout__button checkout__button--error close-error-message">
                    {{ $t('errors_new.tryAgain') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    computed: {
        ...mapGetters(['product']),
        ...mapState(['popup', 'supportEmail', 'fb_user_info']),
        errorCode() {
            return this.popup.errorCode;
        },
        currentLanguage() {
            return window.App.language;
        },
        isGerman() {
            return this.currentLanguage === 'de';
        },
        isRTL() {
            return window.App.isRTL;
        },
    },
    methods: {
        close() {
            this.$store.commit('clearErrorCode');
        },
        enterEmail() {
            this.$store.commit('openCheckout', {
                step: 1,
                errorCode: null,
            });
        },
    },
};
</script>
